import {
  ADLIKE_UPDATE_SUCCESS,
} from "../types/adTypes";
import {
  ADCOMMENT_NEW_SUCCESS,
  ADCOMMENT_LIKE_SUCCESS,
} from "../types/adCommentTypes";
import {
  FAQ_NEW_SUCCESS,
  FAQ_UPDATE_SUCCESS,
} from "../types/adFaqTypes";
import {
  AD_FEED_NEW_SUCCESS,
  AD_FEED_LIKE_SUCCESS,
} from "../types/adListTypes";
import {
  SEARCH_MISS_NEW_SUCCESS,
  SEARCH_MISS_WANT_SUCCESS,
} from "../types/searchMissTypes";
import {
  WALL_ADD_COMMENT_SUCCESS,
  WALL_UPDATE_LIKE_SUCCESS,
} from "../types/wallTypes";

function matchesCountry(state, countryId) {
  if (!countryId) return true;
  const userCountry = state.session?.auth?.country_id;
  if (!userCountry) return true;
  return String(userCountry) === String(countryId);
}

export const handleFeedUpdate = (payload) => (dispatch, getState) => {
  const { Kind, TempId, CommentId, CountryId, FromUserId, Body } = payload || {};
  if (!Kind || !Body) return;

  const state = getState();
  const currentUserId = String(state.session?.auth?.id || "");

  if (FromUserId && String(FromUserId) === currentUserId) {
    return;
  }

  if (!matchesCountry(state, CountryId)) {
    return;
  }

  switch (Kind) {
    case "AD_PUBLISH":
      dispatch({
        type: AD_FEED_NEW_SUCCESS,
        item: Body,
      });
      break;

    case "AD_LIKE":
      if (state.ad?.item?.Id === Body.Id) {
        dispatch({ type: ADLIKE_UPDATE_SUCCESS, item: Body });
      }
      dispatch({ type: AD_FEED_LIKE_SUCCESS, item: Body });
      break;

    case "COMMENT":
      dispatch({ type: WALL_ADD_COMMENT_SUCCESS, item: Body });
      break;

    case "SUBCOMMENT":
      dispatch({
        type: ADCOMMENT_NEW_SUCCESS,
        item: Body,
        parentCommentId: CommentId || TempId,
      });
      break;

    case "COMMENT_LIKE":
      if (CommentId) {
        dispatch({
          type: ADCOMMENT_LIKE_SUCCESS,
          item: Body,
          parentCommentId: CommentId,
        });
      } else {
        dispatch({ type: WALL_UPDATE_LIKE_SUCCESS, item: Body });
      }
      break;

    case "FAQ_QUESTION":
      dispatch({
        type: FAQ_NEW_SUCCESS,
        item: Body,
        goderId: TempId,
      });
      break;

    case "FAQ_ANSWER":
      dispatch({
        type: FAQ_UPDATE_SUCCESS,
        item: Body,
        goderId: TempId,
      });
      break;

    case "SEARCH_MISS":
      dispatch({
        type: SEARCH_MISS_NEW_SUCCESS,
        item: Body,
      });
      break;

    case "SEARCH_MISS_WANT":
      dispatch({
        type: SEARCH_MISS_WANT_SUCCESS,
        item: Body,
      });
      break;

    default:
      break;
  }
};
